const baseStyle = {
  button: {
    borderColor: 'white',
  },
  icon: {
    borderColor: 'sandstone.45',
  },
}

const defaultProps = {
  size: 'md',
  variant: 'active',
}

const sizes = {
  sm: {},
  md: {},
}

const variants = {
  active: {
    button: {
      bg: 'seaBlue.main',
    },
    icon: {
      bg: 'white',
      borderColor: 'seaBlue.main',
      color: 'seaBlue.main',
    },
  },
  completed: {
    button: {
      bg: 'landGreen.41',
    },
    icon: {
      bg: 'white',
      borderColor: 'landGreen.41',
      color: 'landGreen.41',
    },
  },
  optional: {
    button: {
      bg: 'white',
      borderColor: 'seaBlue.45',
      color: 'seaBlue.45',
    },
    icon: {
      bg: 'white',
      borderColor: 'seaBlue.45',
      color: 'seaBlue.45',
    },
  },
  pending: {
    button: {
      bg: 'sandstone.90',
      color: 'sandstone.45',
    },
    icon: {
      bg: 'white',
      borderColor: 'sandstone.45',
      color: 'sandstone.45',
    },
  },
  error: {
    button: {
      bg: 'energyRed.45',
      color: 'white',
    },
    icon: {
      bg: 'white',
      borderColor: 'energyRed.45',
      color: 'energyRed.45',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
